module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/clubprogram-reports/components/declined-report/declined-report.component.css
// module id = ./src/app/shared/clubprogram-reports/components/declined-report/declined-report.component.css
// module chunks = main